
import { put, call } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { startSubmit, stopSubmit, reset } from 'redux-form'

import * as colors from 'material-ui/styles/colors';

import moment from 'moment'

import * as commons from '../commons'
import * as actions from '../actions'

export function* handleInit(action) {

  const resCheck = yield call(fetchData, action.payload.userId)

}

function* fetchData(userId) {

  yield put(actions.reducerAppLoading(true))

  const res = yield call(commons.get2, `/bg/subHoliday/${userId}`)

  const resCheck = yield call(errorCheck, res)
  if (!resCheck) {
    return
  }

  yield put(actions.reducerSubHolidayInit(res.result))

  yield call(delay, 300)

  yield put(actions.reducerAppLoading(false))

}


export function* handleRegist(action) {

  const { form, userId } = action.payload

  yield put(startSubmit(`subHolidayMasterForm`))
  yield put(actions.reducerAppLoading(true))

  if (!form.subHolidayContents) {
      yield put(actions.reducerSnackBar(true, '登録しました。', colors.green400))
      yield put(actions.reducerAppLoading(false))
      return
  }

  let newForm = {
    subHolidayContents: yield call(convertDate, form.subHolidayContents),
  }

  const registRes = yield call(commons.post2, `/bg/subHoliday/${userId}`, newForm)

  const registCheck = yield call(errorCheck, registRes)
  if (!registCheck) {
    return
  }

  const fetchRes = yield call(commons.get2, `/bg/subHoliday/${userId}`)

  const fetchResCheck = yield call(errorCheck, fetchRes)
  if (!fetchResCheck) {
    return
  }

  yield put(actions.reducerSubHolidayInit(fetchRes.result))

  yield call(delay, 300)

  yield put(stopSubmit(`subHolidayMasterForm`))

  yield put(actions.reducerSnackBar(true, '登録しました。', colors.green400))
  yield put(actions.reducerAppLoading(false))

}

function* convertDate(list) {
  return list.map(x => {

    return {
      workHolidayAll: x.workHolidayAll ? moment(new Date(x.workHolidayAll)).format('YYYY/MM/DD') : "",
      workHolidayHarf: x.workHolidayHarf ? moment(new Date(x.workHolidayHarf)).format('YYYY/MM/DD'): "",
      subHoliday1: x.subHoliday1 ? moment(new Date(x.subHoliday1)).format('YYYY/MM/DD'): "",
      subHoliday2: x.subHoliday2 ? moment(new Date(x.subHoliday2)).format('YYYY/MM/DD') : "",
      changeMoney: x.changeMoney,
      changeMoneyComplete: x.changeMoneyComplete,
      comment: x.comment,
      isAdmin: x.isAdmin,
    }
  })
}

function* errorCheck(res) {

  if (!res) {
    yield put(stopSubmit(`subHolidayMasterForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.status && res.status == 401) {
    yield put(actions.reducerSnackBar(true, 'セッションタイムアウト（30分）しました。', colors.red400))
    yield put(stopSubmit(`subHolidayMasterForm`))
    yield put(actions.reducerSetAuth({}, 9))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.fetchError || (res.status && res.status != 200)) {
    yield put(stopSubmit(`subHolidayMasterForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }

  if (res.error) {
    const { field, message } = res.error
    yield put(stopSubmit(`subHolidayMasterForm`, { ...field }))
    yield put(actions.reducerSnackBar(true, message, colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }

  return true
  }


// WEBPACK FOOTER //
// ./src/sagas/subHoliday.js